<template>
    <UiForm ref="form" :data="data" :rules="rules">
        <div class="row">
            <UiFormItem prop="coordinate" :label="$t('Site')">
                <UiScopeInput name="coordinate" v-model="data.coordinate" :placeholder="cPlaceholder" @change="changeCoordinate" />
            </UiFormItem>

            <UiFormItem prop="ref" :label="$t('ReferenceBase')">
                <UiInput name="ref" v-model="data.ref" :readonly="true" placeholder="" />
            </UiFormItem>

            <UiFormItem prop="alt" :label="$t('Mutant')">
                <UiInput
                    ref="alt"
                    name="alt"
                    v-model="data.alt"
                    :candidates="candidate"
                    :placeholder="$t('MutantSequence')"
                    @change="changeAlt"
                    @focus="nextTick(() => (show = true))"
                    @blur="nextTick(() => (show = false))" />
                <UiIcon class="row-arrow" :class="{ active: show }" v-show="candidate.length" name="arrow" @mousedown="methods.focus" />
            </UiFormItem>
        </div>
    </UiForm>
</template>

<script lang="ts" setup>
import { UiIcon, UiForm, UiInput, UiFormItem, UiScopeInput } from "various-ui";
import { useComposable } from "./src/composable";

const emit = defineEmits<{ (event: "redraw", data: any): void }>();

const { refs, data, nodes, rules, methods } = useComposable(emit);
const { show, candidate, cPlaceholder } = refs;
const { form, alt } = nodes;
const { changeCoordinate, changeAlt } = methods;

defineExpose({ init: methods.init, submit: methods.submit, changeData: methods.changeData });
</script>

<style lang="less" scoped>
.ui-form {
    .row {
        display: flex;
        margin-top: 24px;
        justify-content: space-between;
        .row-arrow {
            top: 10px;
            right: var(--uioption-form-spacing-x);
            cursor: pointer;
            position: absolute;
            font-size: 20px;
            transition: all 0.3s;
            &.active {
                transform: rotate(180deg);
            }
        }
    }
}
</style>
